import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { CurrencyConverterPurePipe } from '../../currency-converter-pure.pipe';
import { setting } from '../../../../../setting';

moment.locale('es');

@Component({
  selector: 'usb-insurance-quote-modal',
  templateUrl: './insurance-quote-modal.component.html',
  styleUrls: ['./insurance-quote-modal.component.scss'],
  providers: [CurrencyConverterPurePipe]
})
export class InsuranceQuoteModalComponent implements OnInit {

  public currencies: any;
  public currencyAgency: any;
  public clientSetting: any;
  public styleSidebar: any;
  public insurances: any[] = [];
  public loadInsurance = false;
  public quote = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InsuranceQuoteModalComponent>,
    private currencyPipe: CurrencyConverterPurePipe
  ) {
    if (this.data?.insurancePlan) {
      this.groupInsurance();
      if (this.insurances && this.insurances.length > 0) {
        this.loadInsurance = true;
      }
    }
  }

  ngOnInit() {
    this.clientSetting = this.data?.clientSetting || JSON.parse(localStorage.getItem(setting.name));
    this.currencies = this.data?.currencies;
    this.currencyAgency = this.data?.currencyAgency;
    this.quote = this.data?.quote;
    this.styleSidebar = this.clientSetting?.clients_setting_app_booking
      ? JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar)
      : null;
  }

  formatDate(date: string): string {
    if (!date) {
return '';
}
    return moment(date).format('ddd DD MMM YYYY');
  }

  isString(value: any): boolean {
    return typeof value === 'string';
  }

  getTotalPrice(item: any, category: string): any {
    const price = this.currencyPipe.transform(
      item.totalPriceProf,
      item?.pricing?.currency,
      this.currencyAgency?.code,
      this.currencies
    );
    if (price) {
      return price.toFixed(2);
    }
  }

  groupInsurance(): any[] {
    if (!this.data?.insurancePlan || this.data.insurancePlan.length === 0) {
      return [];
    }

    const groupedInsurances: any = {};

    this.data.insurancePlan.forEach((insurance: any) => {
      const key = `${insurance.insurance?.plan?.planCode}-${insurance.insurance?.plan?.planId}`;
      const plan = insurance.insurance?.plan;

      if (!groupedInsurances[key]) {
        groupedInsurances[key] = {
          insurance: { ...insurance.insurance },
          items: [insurance],
          ages: [insurance.age],
          totalNetPriceProf: plan?.netPriceProf || 0,
          totalTotalPriceProf: plan?.totalPriceProf || 0,
          totalNetPriceFreeTax: plan?.netPriceFreeTax || 0,
          totalTotalPriceFreeTax: plan?.totalPriceFreeTax || 0,
          totalBlickoins: plan?.blickoins || 0,
          totalCreditBlickoins: plan?.creditBlickoins || 0,
          profility: {
            netPrice: plan?.profility?.netPrice || 0,
            netPriceCategory: plan?.profility?.netPriceCategory || 0,
            netPriceProvider: plan?.profility?.netPriceProvider || 0,
            netPriceBooking: plan?.profility?.netPriceBooking || 0,
          }
        };

        groupedInsurances[key].insurance.plan.pax = {
          quantity: 1,
          ages: [insurance.age]
        };
      } else {
        groupedInsurances[key].items.push(insurance);
        groupedInsurances[key].ages.push(insurance.age);

        // Proveedor sin discriminación por tipo de pasajero (selección por grupo):
        // el precio del plan ya es el del grupo completo, no el de un pasajero
        // individual. Sumarlo de nuevo por cada pasajero agrupado lo multiplicaría
        // por la cantidad de gente incluida. Mismo criterio que
        // InsuranceResultComponent.hasDiscriminatedPaxPricing()/getPricesTotalQuote().
        if (this.hasDiscriminatedPaxPricing(plan)) {
          groupedInsurances[key].totalNetPriceProf += (plan?.netPriceProf || 0);
          groupedInsurances[key].totalTotalPriceProf += (plan?.totalPriceProf || 0);
          groupedInsurances[key].totalNetPriceFreeTax += (plan?.netPriceFreeTax || 0);
          groupedInsurances[key].totalTotalPriceFreeTax += (plan?.totalPriceFreeTax || 0);
          groupedInsurances[key].totalBlickoins += (plan?.blickoins || 0);
          groupedInsurances[key].totalCreditBlickoins += (plan?.creditBlickoins || 0);

          groupedInsurances[key].insurance.plan.profility.netPrice += (plan?.profility?.netPrice || 0);
          groupedInsurances[key].insurance.plan.profility.netPriceCategory += (plan?.profility?.netPriceCategory || 0);
          groupedInsurances[key].insurance.plan.profility.netPriceProvider += (plan?.profility?.netPriceProvider || 0);
          groupedInsurances[key].insurance.plan.profility.netPriceBooking += (plan?.profility?.netPriceBooking || 0);
          groupedInsurances[key].insurance.plan.profility.blickoins += (plan?.profility?.blickoins || 0);
          groupedInsurances[key].insurance.plan.profility.creditBlickoins += (plan?.profility?.creditBlickoins || 0);

          groupedInsurances[key].insurance.plan.blickoins += (plan?.blickoins || 0);
          groupedInsurances[key].insurance.plan.creditBlickoins += (plan?.creditBlickoins || 0);
        }

        groupedInsurances[key].insurance.plan.pax.quantity = groupedInsurances[key].items.length;
        groupedInsurances[key].insurance.plan.pax.ages = [...groupedInsurances[key].ages];
      }
    });

    this.insurances = Object.values(groupedInsurances).map((group: any) => {
      group.insurance.plan.netPriceProf = group.totalNetPriceProf;
      group.insurance.plan.totalPriceProf = group.totalTotalPriceProf;
      group.insurance.plan.netPriceFreeTax = group.totalNetPriceFreeTax;
      group.insurance.plan.totalPriceFreeTax = group.totalTotalPriceFreeTax;
      group.insurance.plan.blickoins = group.totalBlickoins;
      group.insurance.plan.creditBlickoins = group.totalCreditBlickoins;

      const allAddons = group.items
        .filter((item: any) => item.addons && item.addons.length > 0)
        .flatMap((item: any) => item.addons);
      const uniqueAddons = [...new Set(allAddons)];

      return {
        ...group.insurance,
        groupedData: {
          originalItems: group.items,
          totalItems: group.items.length,
          allAges: group.ages,
          totals: {
            netPriceProf: group.totalNetPriceProf,
            totalPriceProf: group.totalTotalPriceProf,
            netPriceFreeTax: group.totalNetPriceFreeTax,
            totalPriceFreeTax: group.totalTotalPriceFreeTax,
            blickoins: group.totalBlickoins,
            creditBlickoins: group.totalCreditBlickoins
          }
        },
        addons: uniqueAddons.length > 0 ? uniqueAddons : null
      };
    });

    return this.insurances;
  }

  getTotalPriceInsurance(): number {


    return this.insurances.reduce((total: number, insurance: any) => total + (
                       this.currencyPipe.transform(insurance?.plan?.profility?.netPriceBooking,
                                                    insurance?.plan?.pricing?.currency,
                                                    this.currencyAgency?.code,
                                                    this.currencies
                                                   ) || 0), 0);
  }

  confirm(): void {
    this.dialogRef.close({ confirm: true, insurances: this.insurances });
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  /**
   * Determina si el plan trae el precio discriminado por tipo de pasajero.
   * Mismo criterio que InsuranceResultComponent.hasDiscriminatedPaxPricing(): lee
   * plan.paxPrices (todavía no lo envían la mayoría de los proveedores de
   * categoría 10, se simula para cuando lo hagan). Si hay menos de 2 tipos con
   * precio propio, no alcanza para discriminar y se trata como grupo.
   */
  private hasDiscriminatedPaxPricing(plan: any): boolean {
    const paxPrices = plan?.paxPrices;
    if (!Array.isArray(paxPrices)) {
      return false;
    }
    const validTypes = paxPrices.filter((p: any) => p?.paxType && (p?.amount || p?.amount === 0));
    return validTypes.length > 1;
  }

}
